import PropTypes from 'prop-types';

export default PropTypes.shape({
  trainNumber: PropTypes.string,
  serviceIdentifier: PropTypes.string,
  recommendedSeats: PropTypes.arrayOf(
    PropTypes.shape({
      coach: PropTypes.string,
      number: PropTypes.string
    })
  )
});
